import { Component, Injectable } from '@angular/core'
import {Router, ActivatedRoute, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import { BaseComponent } from '../../../components/base.component'
import {Customer, Account} from '../../../types'
import { CustomerActions } from '../../../actions/customer-actions'
import {possessive, isAgencySignup} from '../../../utils'
import sweetAlert from '../../../bmAlert'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'tone-page-v1',
  template: `
    <split-view>
    <div left>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12 mt-3">
            <div class="nc-section-icon fas fa-comment"></div>
            <h1 class="nc-section-header">
              About {{ customer?.businessName }}
            </h1>

            <p *ngIf="!isAgencySignup()" class="top-buffer">Tell us about your business.</p>
            <p *ngIf="!isAgencySignup()" class="top-buffer">Your business and brand are unique. Tell us about your business so we can write blogs that fit your brand voice.</p>
            <p *ngIf="isAgencySignup()" class="top-buffer">Your client's business and brand are unique. Tell us about them so we can write blogs that fit their voice.</p>
            <about-nav-v1 [customer]="customer"></about-nav-v1>
          </div>
        </div>
      </div>
    </div>
      <div right>
        <div class="container-fluid big-top-buffer">
          <div class="row">
            <div class="col-sm-12">
              <h2>{{account?.agency ? possessive(customer?.businessName) : 'Your'}} Tone</h2>
              <p class="top-buffer bottom-buffer">
                <span *ngIf="account?.agency">Adjust the sliders to set the general tone of {{possessive(customer?.businessName)}} blog. You can always change this later.</span>
                <span *ngIf="!account?.agency">Adjust the sliders to set the general direction of your blog's tone. You can always change this later.</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">

              <brand-slider-container [leftDetail]="'Topical'" [rightDetail]="'Promotional'" (mouseover)="changeSliderDetailContent('slider1')">
                <input class="brand-slider" type="range" name="points" min="0" max="100" [(ngModel)]="sliderForm.slider1">
              </brand-slider-container>

              <brand-slider-container [leftDetail]="'Light-hearted'" [rightDetail]="'Corporate'" (mouseover)="changeSliderDetailContent('slider2')">
                <input class="brand-slider" type="range" name="points" min="0" max="100" [(ngModel)]="sliderForm.slider2">
              </brand-slider-container>

              <brand-slider-container [leftDetail]="'Bullet points'" [rightDetail]="'Narrative'" (mouseover)="changeSliderDetailContent('slider3')">
                <input class="brand-slider" type="range" name="points" min="0" max="100" [(ngModel)]="sliderForm.slider3">
              </brand-slider-container>

              <brand-slider-container [leftDetail]="'Newsy'" [rightDetail]="'Evergreen'" (mouseover)="changeSliderDetailContent('slider4')">
                <input class="brand-slider" type="range" name="points" min="0" max="100" [(ngModel)]="sliderForm.slider4">
              </brand-slider-container>

              <brand-slider-container [leftDetail]="'B2B/Niche'" [rightDetail]="'General Audience'" (mouseover)="changeSliderDetailContent('slider5')">
                <input class="brand-slider" type="range" name="points" min="0" max="100" [(ngModel)]="sliderForm.slider5">
              </brand-slider-container>

            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div id="sliderDetailContent"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="top-buffer bottom-buffer">
                <button (click)="updateCustomer()" class="block btn btn-primary mr-2">Save & continue</button>
                <button (click)="next()" class="block btn btn-default">Skip for now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </split-view>
  `
})
export class TonePageV1 extends BaseComponent {
  customerId: number;
  account: Account;
  sliderForm: {
    slider1: number,
    slider2: number,
    slider3: number,
    slider4: number,
    slider5: number,
  };
  customer: Customer;
  submitted: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private customerActions: CustomerActions,
    private titleService: Title) {
    super()
  }

  ngOnInit(): void {
    this.titleService.setTitle('Sign Up - Tone')
    const routeObs = this.route.params.subscribe(params => {
      this.clearRouteObservers()
      this.customerId = +params['customerId']
      this.customerActions.loadCustomer(this.customerId)

      // Fetch the customer and observe changes
      this.observeCustomer(this.customerId, c => {
        this.customer = c
        this.resetForm()
      })
    })
    this.observeAccount(a => this.account = a)
    this.observers.push(routeObs)
  }

  resetForm(): void {
    this.sliderForm = {
      slider1: this.customer ? this.customer.slider1 : 50,
      slider2: this.customer ? this.customer.slider2 : 50,
      slider3: this.customer ? this.customer.slider3 : 50,
      slider4: this.customer ? this.customer.slider4 : 50,
      slider5: this.customer ? this.customer.slider5 : 50,
    }
  }

  updateCustomer(): void {
    this.submitted = true
    this.customerActions.updateCustomer(this.customerId, this.sliderForm).then(() => {
      this.next()
    })
  }

  next(): void {
    this.router.navigate(['../', 'online_presence'], { relativeTo: this.route })
  }

  ngAfterViewInit(): void {
    this.changeSliderDetailContent('slider1')
  }

  changeSliderDetailContent(sliderName: string): void {
    if (this.sliderDetailContent[sliderName]) {
      document.getElementById('sliderDetailContent').innerHTML = this.sliderDetailContent[sliderName]
    } else {
      this.changeSliderDetailContent('slider1')
    }
  }

  isDirty(): boolean {
    return Number(this.sliderForm.slider1) !== Number(this.customer.slider1) ||
            Number(this.sliderForm.slider2) !== Number(this.customer.slider2) ||
            Number(this.sliderForm.slider3) !== Number(this.customer.slider3) ||
            Number(this.sliderForm.slider4) !== Number(this.customer.slider4) ||
            Number(this.sliderForm.slider5) !== Number(this.customer.slider5)
  }

   possessive(str: string): string {
     return possessive(str)
   }

   isAgencySignup(): boolean {
     return isAgencySignup(this.account)
   }

  sliderDetailContent: Object = {
    'slider1': `
      <p>Examples:</p>
      <label>Topical:</label>
      <p class="form-input-detail">A recent Wall St. Journal story detailed three positive aspects of this industry. Here's how those three relate to our specific niche:</p>
      <label>Promotional:</label>
      <p class="form-input-detail">Here are three reasons why this company is unique in this industry, and how those three reasons can help you do better in this niche:</p>
    `,
    'slider2': `
      <p>Examples:</p>
      <label>Light-hearted:</label>
      <p class="form-input-detail">If Elvis Presley were alive today, he might change his song from Blue Suede Shoes to Green Recycled Sandals.</p>
      <label>Corporate:</label>
      <p class="form-input-detail">A recent study released by Forrester Research indicates a 37 percent jump in application of environmentally sensitive applications within this niche.</p>
    `,
    'slider3': `
      <p>Examples:</p>
      <label>Bullet points:</label>
        <ul>
          <li>
            <p class="form-input-detail">Jack and Jill</p>
          </li>
          <li>
            <p class="form-input-detail">Went up hill</p>
          </li>
          <li>
            <p class="form-input-detail">Fetched water</p>
          </li>
        </ul>

      <label>Narrative:</label>
      <p class="form-input-detail">Two children from nearby, Jack and Jill, climbed up a small hill in the neighborhood with the goal of returning with a pail of water.</p>
    `,
    'slider4': `
      <p>Examples:</p>
      <label>Newsy:</label>
      <p class="form-input-detail">The recent headlines from our niche serve as a stark reminder of the importance of using safe methods for achieving success in this industry.</p>
      <label>Evergreen:</label>
      <p class="form-input-detail">These three methods of improving safety for our niche have been well tested. If you want to achieve success in the industry, you'll want to keep these handy:</p>
    `,
    'slider5': `
      <p>Examples:</p>
      <label>B2B/Niche:</label>
      <p class="form-input-detail">According to the trade journal Widgets Daily, the three advantages of this technology are...</p>
      <label>General Audience:</label>
      <p class="form-input-detail">A recent story in the New York Times highlights the way that this technology can be so interesting.</p>
    `
  };
}

@Injectable()
export class CanDeactivateTonePageV1 implements CanDeactivate<TonePageV1> {
  canDeactivate(component: TonePageV1, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>|boolean {
     if (component.customer && component.isDirty() && !component.submitted) {
      return sweetAlert.confirm({text: "You have unsaved changes, are you sure you want to continue?"})
    } else {
      return true
    }
   }
}
